import {
  createFileRoute,
  Outlet,
  redirect,
  useMatch,
} from "@tanstack/react-router";
import { getMyProfile } from "api-client";

import { CoachProfileLayout } from "src/components/CoachProfileLayout";
import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_auth/_coach/profile")({
  component: RoutePage,
  staticData: {
    getBreadcrumb({ i18n }) {
      return {
        href: "/profile/links",
        label: i18n.t("publicProfile"),
      };
    },
  },
  beforeLoad(options) {
    if (options.location.pathname === "/profile") {
      throw redirect({
        to: "/profile/$section",
        params: { section: "links" },
      });
    }
  },
  async loader() {
    return await loaderHandler(async ({ session }) => {
      if (!session?.coach) {
        throw redirect({ to: "/settings" });
      }

      const response = await getMyProfile();
      return {
        data: { profile: response.data.data.profile },
      };
    });
  },
});

function RoutePage() {
  const editorSection = useMatch({
    from: "/_auth/_coach/profile/$section",
    shouldThrow: false,
    select: (match) => match.params.section,
  });
  const isLeadsSection = useMatch({
    from: "/_auth/_coach/profile/leads",
    shouldThrow: false,
    select: () => true,
  });
  const section = isLeadsSection
    ? "leads"
    : editorSection === "design"
      ? "design"
      : "links";

  return (
    <CoachProfileLayout section={section}>
      <Outlet />
    </CoachProfileLayout>
  );
}
